import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = ({ error }) => {
  const getErrorMessage = (error) => {
    if (error.networkError) {
      return 'ネットワークエラーが発生しました。サーバーに接続できません。';
    }
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      return error.graphQLErrors[0].message;
    }
    return error.message || '不明なエラーが発生しました。';
  };

  return (
    <div className="error-container">
      <div className="error-message">
        <div className="error-icon">⚠️</div>
        <h3>エラーが発生しました</h3>
        <p>{getErrorMessage(error)}</p>
        <button
          className="retry-button"
          onClick={() => window.location.reload()}
        >
          🔄 再読み込み
        </button>
      </div>
    </div>
  );
};

export default ErrorMessage;
